import VideoPlayer from '../../VideoPlayer/VideoPlayer';


interface Props {
  url: string;
  evaluation?: boolean;
  noUnderlined?: boolean;
}

const FormVideos = ({ url, evaluation, noUnderlined = false }: Props) => {
  return (
    <>
      <div className={evaluation ? "flex self-center justify-center md:w-[50%] m-2 mb-2" : "flex self-center justify-center md:w-[80%] m-2 mb-2"} style={{ boxShadow: '0px 0px 16px -2px rgb(107 114 128)'}}>
        <VideoPlayer 
          autoplay={evaluation ? false : true}
          url={url}
        />
      </div>
      {noUnderlined ? (
        <div className="mb-2"></div>
      ) : (
        <hr className={evaluation ? 'bg-gray-500 w-full md:w-[70%] h-[1px]' : 'bg-gray-500 w-full h-[1px]'} style={{ boxShadow: '0px 0px 16px 2px rgb(75 85 99)'}}/>
      )}
    </>
  )
}

export default FormVideos